import React from "react";
import { ContainerPanel } from "@components/organisms/container-panel/container-panel";
import { SubHeader } from "@components/atoms/sub-header/sub-header";
import { ContainerPane } from "@components/organisms/container-pane/container-pane";

import { MachineStructureDropAreaDeactivationOverlayContainer } from "@components/templates/layouts/machine-structure-drop-area-deactivation-overlay-container/machine-structure-drop-area-deactivation-overlay";

import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { TransferConfigurationToClientButton } from "@src/components/atoms/transfer-configuration-to-client-button/transfer-configuration-to-client-button";
import { MachineStructurePanelControlBar } from "@src/components/molecules/machine-structure-panel-control-bar/machine-structure-panel-control-bar";
import TreeViewMachineStructure from "../tree-structure/tree-components/tree-view-machine-structure";
import { useMachineStructurePanelHook } from "./use-machine-structure-panel-hook";
import { RenderIfUserHasMultiplePermissions } from "@src/components/molecules/render-if-user-has-multiple-permissions/render-if-user-has-multiple-permissions";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import { TimezoneDate } from "@src/components/atoms/timezone-date/timezone-date";
import styles from "./machine-structure-panel.module.scss";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import SpinnerWithVariant from "@src/components/atoms/SpinnerWithVariant/spinner-with-variant";
import { Button } from "@src/components/atoms/buttons/button/button";
import { calcContentPaneHeight } from "@src/cloud-connect/utils/calculate-content-pane-height";
import Spinner from "@src/components/atoms/spinner/spinner";

const cssClassName = "machine-structure-panel";
export const MachineStructurePanel = () => {
  const {
    machineStructureFlatMapSize,
    texts,
    lastUpdatedAt,
    loadingLastUpdatedAt,
    refreshingTwinStructure,
    refreshTwinStructure,
  } = useMachineStructurePanelHook();

  return (
    <MachineStructureDropAreaDeactivationOverlayContainer>
      <ContainerPanel>
        <SubHeader>
          {/*             <FlexRowContainer horizontalGap={4}> */}
          {/*               <div ref={saveInputAndButtonWrapperRef}>
                <FlexRowContainer horizontalGap={4}>
                  {subTitleOrInputHandler()}
                  {renameNodeStructureButtonHandler()}
                </FlexRowContainer>
              </div> */}
          {/*             </FlexRowContainer> */}
          <FlexRowContainer horizontalGap={4} justifyContent="space-between">
            <FlexColumnContainer verticalGap={2}>
              <SubTitle text={texts.subTitle} />
              <p className={styles[`${cssClassName}__last-updated-at`]}>
                {texts.lastReceivedAt}
                {loadingLastUpdatedAt ? (
                  <span className={styles[`${cssClassName}__spinner-wrapper`]}>
                    <SpinnerWithVariant variant="extra-small" />
                  </span>
                ) : lastUpdatedAt ? (
                  <TimezoneDate date={lastUpdatedAt} />
                ) : (
                  texts.noTimestampAvailable
                )}
              </p>
            </FlexColumnContainer>
            <div className={styles[`${cssClassName}__actions`]}>
              <Button
                fun={refreshTwinStructure}
                text={texts.refreshButtonText}
                disabled={refreshingTwinStructure}
                variant="secondary"
              />
              <RenderIfUserHasMultiplePermissions
                permissions={[
                  "manage-active-nodeset",
                  "manage-dashboards",
                  "manage-condition-monitoring",
                ]}
                requireAll={true}
              >
                <TransferConfigurationToClientButton />
              </RenderIfUserHasMultiplePermissions>
            </div>
          </FlexRowContainer>
        </SubHeader>
        <ContainerPane>
          <div className={styles[`${cssClassName}__tree-content-wrapper`]}>
            {machineStructureFlatMapSize > 1 && (
              <MachineStructurePanelControlBar />
            )}
            <TreeViewMachineStructure />

            {refreshingTwinStructure && (
              <div
                data-testid="machine-tree-refresh-loader"
                className={styles[`${cssClassName}__tree-refresh-loader`]}
                style={{
                  height: calcContentPaneHeight(
                    machineStructureFlatMapSize > 1 ? 341 : 397,
                  ),
                }}
              >
                <Spinner />
              </div>
            )}
          </div>
        </ContainerPane>
      </ContainerPanel>
    </MachineStructureDropAreaDeactivationOverlayContainer>
  );
};
